import lazyPage from "../../../../../../common/helpers/lazyPage";

export default lazyPage(
    "src/front/components/Task/types/RhytName/RhytLadder/RhytLadder.tsx",
    () => import("./RhytLadder"),
);
